// Outside the router: this blocks login as well as an authenticated mailbox.
export function showUpdateGate(reload: () => Promise<void>) {
  const overlay = document.createElement('div');
  overlay.className = 'fixed inset-0 z-[9999] flex items-center justify-center bg-bmail-surface p-6 text-bmail-text';
  overlay.setAttribute('role', 'alertdialog');
  overlay.setAttribute('aria-modal', 'true');
  overlay.setAttribute('aria-labelledby', 'update-gate-title');
  overlay.setAttribute('aria-describedby', 'update-gate-description');
  const panel = document.createElement('div');
  panel.className = 'w-full max-w-sm rounded-xl border border-bmail-border bg-bmail-surface p-6 text-center shadow-xl';
  const title = document.createElement('h1');
  title.id = 'update-gate-title';
  title.className = 'text-xl font-semibold';
  title.textContent = '🐝 A new version of B-Mail is ready';
  const description = document.createElement('p');
  description.id = 'update-gate-description';
  description.className = 'my-4';
  description.textContent = 'Reload to install it.';
  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'rounded-lg bg-bmail-goldfill px-6 py-3 font-semibold text-bmail-on-accent hover:bg-bmail-goldfill-hover';
  button.textContent = 'Reload';
  let busy = false;
  button.onclick = () => {
    if (busy) return;
    busy = true;
    button.textContent = '🐝 Installing…';
    void reload().catch(() => { busy = false; button.textContent = 'Reload'; });
  };
  overlay.addEventListener('keydown', (event) => {
    if (event.key === 'Tab' || event.key === 'Escape') { event.preventDefault(); button.focus(); }
  });
  document.addEventListener('focusin', (event) => {
    if (!overlay.contains(event.target as Node)) button.focus();
  });
  panel.append(title, description, button);
  overlay.append(panel);
  document.body.append(overlay);
  button.focus();
}
